import EA from 'helpers/init';
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import 'swiper/css';

export default EA.Methods.gallerySlider = ($this) => {
    const slider = $this.querySelector('.swiper');
    const prev = $this.querySelector('.prev');
    const next = $this.querySelector('.next');

    new Swiper(slider, {
        modules: [Navigation],
        speed: 1200,
        spaceBetween: 18,
        slidesPerView: 'auto',
        allowTouchMove: true,
        navigation: {
            prevEl: prev,
            nextEl: next
        },
        breakpoints: {
            769: {
                spaceBetween: 24
            }
        }
    });
};
